import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../../Interfaces/ReduxSliceInterface";

const initialState: AuthState = {
  accessToken: "",
  refreshToken: "",
  accessExpiresInSec: undefined,
  refreshExpiresAt: undefined,
  jti: undefined,
};

const authSlice = createSlice({
  name: "authReducer",
  initialState,
  reducers: {
    // Save tokens when login is successful
    setTokens: (
      state,
      action: PayloadAction<{ 
        accessToken: string; 
        refreshToken: string;
        accessExpiresInSec?: number;
        refreshExpiresAt?: string;
        jti?: string;
      }>
    ) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      if (action.payload.accessExpiresInSec !== undefined) {
        state.accessExpiresInSec = action.payload.accessExpiresInSec;
      }
      if (action.payload.refreshExpiresAt !== undefined) {
        state.refreshExpiresAt = action.payload.refreshExpiresAt;
      }
      if (action.payload.jti !== undefined) {
        state.jti = action.payload.jti;
      }
    },
    // Clear tokens on logout
    clearTokens: (state) => {
      state.accessToken = "";
      state.refreshToken = "";
      state.accessExpiresInSec = undefined;
      state.refreshExpiresAt = undefined;
      state.jti = undefined;
    },
  },
});

export const { setTokens, clearTokens } = authSlice.actions;
export default authSlice.reducer;
